import { RootState } from "../../../core/store";
import { STOPPAGE_EVENTS_REPORT, TStoppageEventsReportSliceState, TReportRequestParams } from "../types/downloadTypes";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: TStoppageEventsReportSliceState = {
    stoppageEventsData: null,
    stoppageEventsLoading: false,
    stoppageEventsError: null,
};

const stoppageEventsReportSlice = createSlice({
    name: STOPPAGE_EVENTS_REPORT,
    initialState,
    reducers: {
        submitStoppageEventsReportRequestAction: (state: TStoppageEventsReportSliceState, _: PayloadAction<TReportRequestParams>) => {
            state.stoppageEventsLoading = true;
            state.stoppageEventsError = null;
            state.stoppageEventsData = null;
        },
        submitStoppageEventsReportSuccessAction: (state: TStoppageEventsReportSliceState, { payload: data }: PayloadAction<any>) => {
            state.stoppageEventsLoading = false;
            state.stoppageEventsData = data;
            state.stoppageEventsError = null;
        },
        submitStoppageEventsReportErrorAction: (state: TStoppageEventsReportSliceState, { payload: error }: PayloadAction<any>) => {
            state.stoppageEventsLoading = false;
            state.stoppageEventsData = null;
            state.stoppageEventsError = {
                message: (error.response && error.response.data) || error.message || '',
                name: error.name,
                stack: error.stack,
            };
        },
        clearStoppageEventsReportStateAction: (state: TStoppageEventsReportSliceState) => {
            state.stoppageEventsLoading = false;
            state.stoppageEventsData = null;
            state.stoppageEventsError = null;
        },
    },
});

export const portCallsReportActions = {
    ...stoppageEventsReportSlice.actions
};

export default stoppageEventsReportSlice.reducer;

export const selectStoppageEventsReportData = (state: RootState) =>
    state.stoppageEventsReportSlice.stoppageEventsData;
export const selectStoppageEventsReportLoading = (state: RootState) =>
    state.stoppageEventsReportSlice.stoppageEventsLoading;
export const selectStoppageEventsReportError = (state: RootState) =>
    state.stoppageEventsReportSlice.stoppageEventsError;
